import { isAndroid, isIOS } from '@e3dc-react/shell/Configuration'
import { getWebviewPortalVersion } from '@e3dc-react/shell/Libs/webview'
import React from 'react'
import { requiresAppUpdate } from '../utils/app-version'
import AppUpdatePage from './AppUpdatePage'
import { ANDROID_APP_STORE_LINK, IOS_APP_STORE_LINK } from 'src/Libs/app-rating/consts'
import { AppTheme } from '@e3dc-react/shell/State/App/AppModel'

interface Props {
  requiredAppVersion: {
    [key in AppTheme]?: string
  }
  activeForIos?: boolean
  activeForAndroid?: boolean
  children: React.ReactNode
}

/**
 * Wraps app content and shows a page to enforce mobile app update if required
 * @prop requiredAppVersion: object with theme as key and required app version as value, e.g. { flow: '1.0.10', e3dc: '1.0.5' }
 */
const AppUpdateWrapper: React.FC<Props> = ({ requiredAppVersion, activeForAndroid = false, activeForIos = false, children }) => {
  const mobileAppVersion = getWebviewPortalVersion()
  const doesPlatformRequireUpdate = (isIOS && activeForIos) || (isAndroid && activeForAndroid)
  const themedRequiredAppVersion = requiredAppVersion[process.env.REACT_APP_THEME as AppTheme] || '0.0.0'
  const doesAppVersionRequireUpdate = requiresAppUpdate(mobileAppVersion, themedRequiredAppVersion)
  const doesNotRequireUpdate = !doesPlatformRequireUpdate || !doesAppVersionRequireUpdate

  if (doesNotRequireUpdate) return children

  const onActionClick = (): void => {
    if (isIOS) window.open(IOS_APP_STORE_LINK, '_blank', 'noopener,noreferrer')
    if (isAndroid) window.open(ANDROID_APP_STORE_LINK, '_blank', 'noopener,noreferrer')
  }

  return <AppUpdatePage onActionClick={onActionClick} />
}

export default AppUpdateWrapper
